import React from "react";
import { useCountUp } from "./Shared";
import { STATS } from "../config/siteConfig";

const StatItem = ({ value, suffix, label }) => {
  const { val, ref } = useCountUp(value);
  return (
    <div ref={ref} className="text-center md:text-left" data-testid="stat-item">
      <div className="font-display text-5xl md:text-6xl lg:text-7xl text-white leading-none tracking-tight">
        {val}
        <span className="text-[#E03535]">{suffix}</span>
      </div>
      <div className="overline text-white/50 text-[11px] mt-4">{label}</div>
    </div>
  );
};

export const Stats = () => (
  <section className="bg-[#111111] py-20 md:py-24" data-testid="stats-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
      {STATS.map((s) => (
        <StatItem key={s.label} {...s} />
      ))}
    </div>
  </section>
);

export default Stats;
